export default __webpack_public_path__ + "static/media/city.fcf061d2.png";